// extracted by mini-css-extract-plugin
export var darkMode = "_f-0";